export function getDomain(hostname) {
  const parts = hostname.split(".");

  // Para dominios como 'midominio.com'
  if (parts.length === 2) {
    return hostname;
  }

  // Para subdominios como 'app.midominio.com'
  if (parts.length >= 3) {
    return parts.slice(-2).join(".");
  }

  // Para localhost o IPs
  return hostname;
}
